/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */

import React, {useEffect, useState} from 'react'
import 'semantic-ui-css/semantic.min.css';
import Footer from '../Common/Footer'
import ResponsiveContainer from "../Common/ResponsiveContainer";
import Portfolio from "./components/Portfolio";
import {Divider} from "semantic-ui-react";

const Boeken = () => {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        const resizeListener = () => {
            setScreenWidth(window.innerWidth);
        };
        window.addEventListener('resize', resizeListener);

        return () => {
            window.removeEventListener('resize', resizeListener);
        }
    }, []);

    return (
        <ResponsiveContainer>
            <Portfolio screenWidth={screenWidth}/>
            <Divider style={{color: 'black', height: '5px'}}/>
            <Footer/>
        </ResponsiveContainer>
    );
}

export default Boeken
